import React from 'react'
import classNames from 'classnames'
import { Box } from '@chakra-ui/react'

import { DangerouslySetInnerHTML } from 'front-end/src/utils/DangerouslySetInnerHTML'

import * as quizUtils from '../utils'
import { QuizElementType } from '../../constants/QuizElementTypes'
import { brandColors } from 'shared/basicPalette'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'

export const QuizElementWrapper = ({ element, children }) => {
  const type = element.type
  const className = classNames('QuizElement QuizElement__mode-learn', {
    'QuizElement__type-single': quizUtils.isSingleChoice(type),
    'QuizElement__type-multi': quizUtils.isMultiChoice(type),
    'QuizElement__type-open': quizUtils.isOpenChoice(type)
  })

  return (
    <div className={className}>
      <label
        htmlFor={`element-${element.type}-${element.id}`}
        className="QuizElement__question"
      >
        <DangerouslySetInnerHTML content={element.data?.content as string} />
      </label>
      <Box fontSize={fontSizes.sm} mb="24px" color={brandColors.grey[500]}>
        {QuizElementType[type]}
      </Box>
      <div className="QuizElement__answer">{children}</div>
    </div>
  )
}
